import {createApp} from 'vue';
import {get} from "./data-manager";
import docCookies from 'doc-cookies';
import Animate from "./animate";
export default class RealizationList {
    constructor($el) {
        this.$el = $el;
        this.createVueApp();
    }

    createVueApp() {
        const blockId = this.$el.dataset.blockId;
        const realizationList = this.$el.querySelector('[data-realization-list]');
        const container = this.$el;

        const app = createApp({
            data() {
                return {
                    blockId: blockId,
                    page: 1,
                    realizations: [],
                    totalCount: '',
                    allCount: '',
                    loader : null,
                    count : null,
                    pager: null,
                    loading: null,
                    realizationList: realizationList,
                    brand: null,
                    container: container,
                    isLoaded: false,
                    category: null,
                    isInitialLoad: true
                };
            },
            computed: {
            },
            methods: {
                resetAnimation() {
                    const animatedContainer = this.container.querySelector('[data-realization-list]');

                    if (!animatedContainer) {
                        return;
                    }

                    animatedContainer.classList.remove('animate');
                    void animatedContainer.offsetWidth;
                    animatedContainer.classList.add('animate');
                },
                /**
                 * Get Filters
                 * We get the filters by serializing the form and stripping the empty filters
                 * @returns {{[p: string]: any}}
                 */
                getFilters() {
                    const formData = this.$refs.filters ? new FormData(this.$refs.filters) : new FormData();
                    let filters = Object.fromEntries(formData);

                    filters = Object.fromEntries(
                        Object.entries(filters).filter(
                            ([filter, value ]) => {
                                if (value) {
                                    return [filter, value];
                                }
                            }
                        )
                    );

                    return filters;
                },
                /**
                 * Set the current filters in the url
                 * @param filters
                 */
                setFiltersInUrl(filters) {
                    const url = new URL(window.location.href);
                    url.search = (new URLSearchParams(filters)).toString();

                    window.history.pushState({},"", url.toString())
                },
                /**
                 * Set filters by the active url
                 */
                getFiltersByUrl() {
                    const params = (new URLSearchParams(window.location.search));

                    if (params.has('category')) {
                        this.category = parseInt(params.get('category'));
                    }
                },
                /**
                 * Set the current filters in the cookie
                 * @param filters
                 */
                setFiltersInCookie(filters) {
                    docCookies.setItem('realization-list-filters', JSON.stringify(filters))
                },
                /**
                 * Check if we have previous filters in a cookie
                 * If so we use them as the starting default
                 */
                getFiltersFromCookie() {
                    const filters = JSON.parse(docCookies.getItem('product-list-filters'));

                    if(! filters) {
                        return;
                    }

                    if (filters.category) {
                        this.category = parseInt(filters.category);
                    }
                },
                /**
                 * Get the product data
                 * @returns {Promise<void>}
                 */
                async fetchItems() {
                    const params = this.getFilters();
                    this.setFiltersInUrl(params);
                    this.setFiltersInCookie(params);

                    const url = `${currentHref}/block/${blockId}/ajax`;

                    if (this.abortController) {
                        this.abortController.abort();
                    }

                    this.loading = true;

                    this.abortController = new AbortController();
                    const result = await get(url, params, this.abortController.signal);

                    if( ! result) {
                        return;
                    }
                    // Set the values we need
                    this.realizations = result.publications;
                    this.pager = result.pager;

                    this.loading = false;

                    this.totalCount = result.totalCount;

                   // this.makePager();



                    this.$nextTick(() => {
                        this.resetAnimation();
                        window.initDom(this.$refs.realizations || this.$el);
                    });

                },
                filterCategory(e) {
                    e.preventDefault();
                    let category = e.currentTarget;
                    let categorySlug = category.dataset.category;
                    this.category = categorySlug;
                    this.allCategoriesPassive();
                    category.classList.add('realization-category--active');
                    this.$nextTick(() => {
                        this.fetchItems();
                    });
                },
                allCategoriesPassive()
                {
                    var categories = container.querySelectorAll('[data-category]').forEach((category) => {
                        category.classList.remove('realization-category--active');
                    })
                },
                checkActiveCategory()
                {
                    if( ! this.category) {
                        return;
                    }
                    var category = container.querySelector(`[data-category="${this.category}"]`);
                    if (!category) {
                        return;
                    }
                    category.classList.add('realization-category--active');
                },
                removeFilterCategory(e)
                {
                    e.preventDefault();
                    let category = e.currentTarget;
                    category.classList.remove('realization-category--active');
                    this.category = null;
                    this.allCategoriesPassive();
                    this.$nextTick(() => {
                        this.fetchItems();
                    });
                },
            },
            async mounted() {
                await this.fetchItems();
                this.initialized = true;
                this.checkActiveCategory();
                this.isLoaded = true;
                container.querySelectorAll('[data-animate]').forEach($item => (new Animate($item)));
            },
            created() {
                if (window.location.search) {
                    this.getFiltersByUrl();
                } else {
                    this.getFiltersFromCookie();
                }
            }
        });

        app.config.compilerOptions.delimiters = ['v{', '}'];

        // mount the app
        app.mount(this.$el);
    }

}
